import React, { useEffect } from 'react'
import { GoogleMap,useJsApiLoader } from '@react-google-maps/api'

const containerStyle = {
    width: '400px',
    height: '400px'
  };
  
  const center = {
    lat: -3.745,
    lng: -38.523
  };

const GoogleMap1 = ({postcode}) => {

    // const [map, setMap] = React.useState(null)

    

    // const { isLoaded } = useJsApiLoader({
    //     id: 'google-map-script',
    //     googleMapsApiKey: "AIzaSyBYE-axw0jpfg5HDy9VSxLgV5DtXE-bKjU"
    //   })

    //  const onLoad = React.useCallback(function callback(map) {
    //         // This is just an example of getting and using the map instance!!! don't just blindly copy!
    //         const bounds = new window.google.maps.LatLngBounds(center);
    //         map.fitBounds(bounds);
        
    //         setMap(map)
    //     },[])       

    const MapUrl = 'https://www.google.com/maps/embed/v1/place?key=AIzaSyBYE-axw0jpfg5HDy9VSxLgV5DtXE-bKjU&q='+postcode   

    console.log(postcode)

  return (
    <>
    <div>GoogleMap</div>
             

      <iframe
      width="100%"
      height="250px"
      frameborder="0" style={{border:"0",}}
      src={MapUrl} 
      />
    
    </>
  )
}

export default GoogleMap1